import React from "react";

import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { FormInputField } from "@components-shared/mobile/inputs";
import ErrorBoundaryWithPropagation from "@components/boundary/ErrorBoundaryWithPropagation";
import { FormButton } from "@components/buttons";
import { useRootAppStore } from "@hooks";

import { SupportChatInfoBox } from "../shared";
import ChatCloseButton from "./ChatCloseButton";
import ChatMinimizeButton from "./ChatMinimizeButton";

export default function ChatNameUpdate() {
	const rootStore = useRootAppStore();
	const { t } = useTranslation();

	const methods = useForm({
		mode: "onChange",
		defaultValues: {
			chatName: "",
		},
	});

	const { handleSubmit } = methods;

	const submitData = async (chatName: string) => {
		if (rootStore.userAuthStore.user) {
			await rootStore.chatViewStore.updateChatName(chatName);
		}
	};

	return (
		<>
			<ErrorBoundaryWithPropagation
				componentName={"Mobile/ChatNameUpdate.tsx"}
			>
				<div className="chat__header u-padd--xsml">
					<span className="chat__header__title">
						{t("CHAT.TITLE")}
					</span>

					<div className="chat__header__actions u-mar--reset">
						<ChatMinimizeButton />
						<ChatCloseButton />
					</div>
				</div>

				<div className="chat__box">
					<div className="chat__notice">
						<div className="chat__box__icon-wrapper">
							<i className="u-icon u-icon--xlrg u-icon--user--alt" />
						</div>
						<span className="u-type--sml">
							{t("CHAT.ENTER_CHAT_NAME_DESCRIPTION")}
						</span>
					</div>
					<FormProvider {...methods}>
						<form
							className="chat__footer"
							onSubmit={handleSubmit(
								(formData: { chatName: string }) =>
									submitData(formData.chatName)
							)}
						>
							<SupportChatInfoBox
								store={rootStore.chatViewStore}
							/>
							<div className="chat__textbox">
								<FormInputField
									name="chatName"
									type="string"
									placeholder={t(
										"CHAT.ENTER_CHAT_NAME_PLACEHOLDER"
									)}
									inputClassName="chat__input chat__input--nickname input input--base"
									maxLength={27}
									validate={{
										nameContainsUnderscore: (
											value: string
										) =>
											!value.includes("_") ||
											"CHAT.CANNOT_CONTAIN_UNDERSCORE",
									}}
									required
								/>

								<FormButton
									btnText={t("COMMON.SAVE")}
									className="chat__send btn btn--sml btn--primary"
								/>
							</div>
						</form>
					</FormProvider>
				</div>
			</ErrorBoundaryWithPropagation>
		</>
	);
}
